/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DelegationDeleted,
    DelegationDeletedFromJSON,
    DelegationDeletedFromJSONTyped,
    DelegationDeletedToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface DelegationDeletedResponse
 */
export interface DelegationDeletedResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof DelegationDeletedResponse
     */
    msg: string;
    /**
     * 
     * @type {DelegationDeleted}
     * @memberof DelegationDeletedResponse
     */
    entry: DelegationDeleted;
}

export function DelegationDeletedResponseFromJSON(json: any): DelegationDeletedResponse {
    return DelegationDeletedResponseFromJSONTyped(json, false);
}

export function DelegationDeletedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegationDeletedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': DelegationDeletedFromJSON(json['entry']),
    };
}

export function DelegationDeletedResponseToJSON(value?: DelegationDeletedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': DelegationDeletedToJSON(value.entry),
    };
}


